import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { AuthenticationService, WebAppUser } from '@services/authentication.service';
import { combineLatest, takeUntil, distinctUntilChanged, filter, Subject } from 'rxjs';
import { siteSubscriptions } from '@services/siteSubscriptions';

@Component({
	selector: 'app-unauthorised',
	templateUrl: './unauthorised.component.html',
	styleUrls: ['./unauthorised.component.scss']
})
export class UnauthorisedComponent implements OnInit {

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** currentUser */
	public currentUser: WebAppUser;

	/** attemptedURL */
	public attemptedURL: string = "";

	/** errorMessage */
	public errorMessage: string = "";

	/** source */
	public source: string = "";

	/**
	 * Default Constructor
	 * @param authenticationService authenticationService 
	 * @param siteSubscriptions siteSubscriptions 
	 * @param router router 
	 * @param route route 
	 * @param globalFunctions globalFunctions  
	 */
	constructor(
		public authenticationService: AuthenticationService,
		public siteSubscriptions: siteSubscriptions,
		private router: Router,
		private route: ActivatedRoute,
		private globalFunctions: GlobalFunctions
	) {
		combineLatest([
			this.authenticationService.currentUser$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
		]).pipe(
			// Ensure that subscriptions are not null or undefined
			filter(([currentUser]) => !!currentUser)
		).subscribe({
			next: ([currentUser]) => {
				this.currentUser = currentUser;
			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
			}
		});
	}

	ngOnInit(): void {
		this.attemptedURL = history.state?.url ?? '/';
		this.errorMessage = history.state?.message ?? '';
		this.source = history.state?.source ?? '';
	}

	get issueEmailLink(): string {
		function getPlatformFromUserAgent(): string {
			const ua = navigator.userAgent;

			if (/Windows NT/i.test(ua)) return "Windows";
			if (/Macintosh/i.test(ua)) return "macOS";
			if (/Linux/i.test(ua)) return "Linux";
			if (/Android/i.test(ua)) return "Android";
			if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";

			return "Unknown";
		}
		// const to = 'prismpdm.support@malonegroup.com';
		const to = '"PRISMPdM Support" <prismpdm.support@malonegroup.com>';
		const subject = encodeURIComponent('PRISMPdM Issue Report');

		// Extract environment info
		const userAgent = navigator.userAgent;
		const platform = getPlatformFromUserAgent();
		const screenSize = `${window.screen.width}x${window.screen.height}`;
		const windowSize = `${window.innerWidth}x${window.innerHeight}`;
		const language = navigator.language;
		const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		const isMobile = /Mobi|Android/i.test(userAgent);
		const deviceType = isMobile ? 'Mobile' : 'Desktop';

		const body = encodeURIComponent(
			`Hi Support,

I encountered an issue with the PRISMPdM platform.

Description:
[Please describe the issue here]

---------------------------------------------------------------------
Details:
- Page: ${window.location.href}
- Attempted URL: ${this.attemptedURL}
- Error Message: ${this.errorMessage}
- Source:        ${this.source}
- User: ${this.currentUser?.Name || 'Unknown'}
- Email: ${this.currentUser?.Email || 'Unknown'}

Environment:
- Device Type: ${deviceType}
- Platform: ${platform}
- Language: ${language}
- Timezone: ${timezone}
- Screen Size: ${screenSize}
- Window Size: ${windowSize}
- Browser: ${userAgent}
---------------------------------------------------------------------

Thanks,
${this.currentUser?.Name || 'Unknown'}`
		);

		return `mailto:${to}?subject=${subject}&body=${body}`;
	}
}


